module.exports = __webpack_public_path__ + "_assets/img/teacher-student.55320d81.svg";